export default __webpack_public_path__ + "static/media/governance-token.22d5c95c.png";